enum FinishFlowHandlerId {
  CONTRACT_SIGNING = 'contractSigning',
}

export { FinishFlowHandlerId };
